export default function initSitemap() {
  const buttons = document.querySelectorAll(".sitemap-link-btn")

  buttons.forEach((button) => {
    // Prevent duplicate listeners on Livewire navigations
    if (button.dataset.bound === "true") return
    button.dataset.bound = "true"

    button.addEventListener("click", () => {
      const containers = button.parentNode.getElementsByClassName("content")

      if (containers.length > 0) {
        containers[0].classList.toggle("hidden")
      }
    })
  })
}
